export default __webpack_public_path__ + "static/promo-l4-img-68bcf1d2f3de68db3a1bc881f2943a94.png";